import { Dayjs } from "dayjs";

const dayJSToISOValueKnown = (value: Dayjs): string => {
  return value && value?.isValid()
    ? `${value.format("YYYY-MM-DD")}T00:00:00.000Z`
    : "";
};

export default dayJSToISOValueKnown;
